import { render, staticRenderFns } from "./updateAvailNotif.vue?vue&type=template&id=54a5670c&"
import script from "./updateAvailNotif.vue?vue&type=script&lang=ts&"
export * from "./updateAvailNotif.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports